export const colors = {
  textPrimary: "#1C2431",
  bgPrimary: "#F7F9FC",

  accentPrimary: "#2F7F7A",   // Teal
  accentSecondary: "#E0A458", // Gold

  surface: "#FFFFFF",
  surfaceAlt: "#EFF4F9",
  border: "#D8E1EC",
  topBar: "#0F1F2B",        // Midnight Pine
  sectionAlt: "#E9F0F6",    // Glacier Mist
  
  white: "#FFFFFF",
};

export const fonts = {
  logo: "'Caveat', cursive",
  heading: "'Space Grotesk', sans-serif",
  body: "'Inter', sans-serif",
};

export const fontSizes = {
  logo: 32,
  heroName: 64,
  heroSubhead: 24,
  h1: 32,
  h2: 24,
  h3: 18,
  body: 16,
  small: 14,
};

export const logoStyle = {
  fontFamily: fonts.logo,
  fontSize: fontSizes.logo,
  fontWeight: 700,
  letterSpacing: "-0.02em",
  color: colors.textPrimary,
};

export const headingStyle = {
  fontFamily: fonts.heading,
  color: colors.textPrimary,
};

export const bodyTextStyle = {
  fontFamily: fonts.body,
  fontSize: fontSizes.body,
  lineHeight: 1.65,
  color: colors.textPrimary,
};

export const primaryButton = {
  fontFamily: fonts.heading,
  backgroundColor: colors.accentPrimary,
  color: colors.white,
  padding: "12px 18px",
  borderRadius: 12,
  border: "none",
  cursor: "pointer",
};
